
require([], function() {try{document.querySelectorAll("[data-scc-loaded]").forEach(function(a){window.scc.loaded(a,a.parentElement)})}catch(a){console.log(a)}}); 
define("modules/img-loaded", function(){});
